import React from 'react'

function AgenziaInfo({agenziaData}) {
  return (
    <div className='container'>
        <div className='row'>
            <div className='col-sm-12 col-md-6 my-2'>
            <span className='small text-muted d-block mb-1'><b>Ragione sociale</b></span>
               <span className='d-block'>{agenziaData.denominazione || 'N/A'}</span>
            </div>
            <div className='col-sm-12 col-md-6 my-2'>
            <span className='small text-muted d-block mb-1'><b>Indirizzo</b></span>
               <span className='d-block'>{agenziaData.indirizzo || 'N/A'}</span> 
            </div>
        </div>
        <div className='row'>
            <div className='col-sm-12 col-md-6 my-2'>
            <span className='small text-muted d-block mb-1'><b>CAP</b></span>
               <span className='d-block'>{agenziaData.cap || 'N/A'}</span> 
            </div>
            <div className='col-sm-12 col-md-6 my-2'>
            <span className='small text-muted d-block mb-1'><b>Città</b></span>
               <span className='d-block'>{agenziaData.citta || 'N/A'}</span> 
            </div>
        </div>
        <div className='row'>
            <div className='col-sm-12 col-md-6 my-2'>
            <span className='small text-muted d-block mb-1'><b>Provincia</b></span>
               <span className='d-block'>{agenziaData.provincia || 'N/A'}</span> 
            </div>
            <div className='col-sm-12 col-md-6 my-2'>
            <span className='small text-muted d-block mb-1'><b>Partita iva</b></span>
               <span className='d-block'>{agenziaData.piva || 'N/A'}</span> 
            </div>
        </div>
        <div className='row'>
            <div className='col-sm-12 col-md-6 my-2'>
            <span className='small text-muted d-block mb-1'><b>Referente</b></span>
               <span className='d-block'>{agenziaData.referente || 'N/A'}</span> 
            </div>
            <div className='col-sm-12 col-md-6 my-2'>
            <span className='small text-muted d-block mb-1'><b>Email</b></span>
               <span className='d-block'>{agenziaData.email || 'N/A'}</span> 
            </div>
        </div>
        <div className='row'>
            <div className='col-12 my-2'>
            <span className='small text-muted d-block mb-1'><b>Note</b></span>
               <span className='d-block'>{agenziaData.note || 'N/A'}</span> 
            </div>
        </div>
    </div>
  )
}

export default AgenziaInfo;